import Modal from '@components/App/Modal/Modal'
import NotificationWrapper from '@components/App/NotificationContainer/NotificationWrapper'
import SystemDialogs from '@components/App/SystemDialogs'
import { useRedirectAfterAuth } from '@components/Router/hooks/useRedirectAfterAuth'
import { SitemapReport } from '@components/SitemapReport'
import type React from 'react'
import { useSelector } from 'react-redux'

import { selectIsLoading } from '@/store'

// A report is read by whoever has the link, signed in or not — the same deal a
// shared sitemap gets. The auth check still has to land first: who is asking is
// what decides whether the header offers the actions that change the report.
export const SitemapReportProjects: React.FC = () => {
  const checkingAuth = useSelector(selectIsLoading('authentication'))

  useRedirectAfterAuth()

  if (checkingAuth) {
    return null
  }

  return (
    <>
      <SitemapReport />
      <NotificationWrapper />
      <SystemDialogs />
      <Modal />
    </>
  )
}
